export default __webpack_public_path__ + "static/media/logo-md-course.b24e4ee0.png";